var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverLogoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 980.04 738.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#1d1d1b;}.cls-2{font-size:224.85px;font-family:Enigmatic;letter-spacing:0.03em;}.cls-3{letter-spacing:0.03em;}.cls-4{letter-spacing:0.03em;}.cls-5{letter-spacing:0.02em;}.cls-6{letter-spacing:0.04em;}.cls-7{letter-spacing:0.03em;}.cls-8{letter-spacing:0.03em;}.cls-9{letter-spacing:0.05em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M953.85,461.3c-6.25-66.18-18-161.61-21.86-186.92-.25-1.89-.47-3.56-.62-4.5-3.56-20.26-11.76-65.23-61.92-88-71.7-43.68-291.76-44.8-291.76-44.8s-32.87.25-77,.95c-44.18-.7-77-.95-77-.95s-220.15,1.12-291.84,44.8c-50.15,22.79-58.27,67.76-61.83,88-.23,1-.38,2.61-.68,4.65-3.81,25.32-15.71,121-21.87,187-2.68,28.32-4.33,51.18-3.86,60.88,4.89,46.46,100.72,88.5,100.72,88.5s72.15,30.76,111,34.62c25.71,3.86,83.51-6.15,131.55-17.43,42-9.94,99.7-12.15,113.82-12.55,14.18.4,71.82,2.61,113.8,12.55,48.19,11.28,105.9,21.29,131.53,17.43,38.9-3.86,111-34.62,111-34.62s95.84-42,100.74-88.5C958.17,512.65,956.52,489.61,953.85,461.3ZM676.37,449.62l-.08.4a197.49,197.49,0,0,1-65.77,89.68,189.42,189.42,0,0,1-24,15.54c-2.16,1.17-4.28,2.21-6.4,3.29l-1.51.81-.88.31-1.09.57-3.07,1.4c-2.06.87-4,1.74-6.25,2.68L560.36,567c-2.37,1-4.58,1.53-6.8,2.31s-4.64,1.55-7,2.12l-6.95,1.82-7,1.57a192.78,192.78,0,0,1-28.71,3.63,199.12,199.12,0,0,1-112.14-28,206.52,206.52,0,0,1-24.29-17.13,210,210,0,0,1-21.61-20.58,214.56,214.56,0,0,1-18.38-23.66,228.09,228.09,0,0,1-14.73-26.17l39.26-17a179.47,179.47,0,0,0,10.26,21.61,137.89,137.89,0,0,0,13.4,20,176,176,0,0,0,16.22,18,187.57,187.57,0,0,0,18.8,15.31,167.82,167.82,0,0,0,92.59,30,177.14,177.14,0,0,0,25-1.44,161.38,161.38,0,0,0,24.53-5.11l5.9-1.74c1.91-.64,4.2-1.5,6.3-2.21l3.17-1.18,2.61-1.11c2-.78,3.93-1.65,5.83-2.52a171,171,0,0,0,22.33-12.15,181,181,0,0,0,63.49-73.43L444.19,298.52,673.85,442.37A6,6,0,0,1,676.37,449.62ZM648,318a168.46,168.46,0,0,0-10.17-21.37,160.26,160.26,0,0,0-13.17-19.88,166.78,166.78,0,0,0-126.41-63.56,199.39,199.39,0,0,0-24.71,1.18,171.79,171.79,0,0,0-24.45,4.81l-5.83,1.67c-.95.37-2,.54-2.92.93l-3.23,1.11L434,224.07l-1.57.53-.47.17h-.08l-.15.15-.47.17-5.83,2.44a161.61,161.61,0,0,0-22.18,11.91A180.74,180.74,0,0,0,339,310.89l219,149L327.46,318.48a6.13,6.13,0,0,1-3-5.22,4,4,0,0,1,.32-1.73,1,1,0,0,1,.07-.48l.16-.39a193.25,193.25,0,0,1,90.77-103l6.31-3.24.77-.47,1-.4,1.58-.62,3-1.34,3.17-1.42c1-.48,2.19-.87,3.38-1.35,2.29-.87,4.51-1.74,6.88-2.59a211.8,211.8,0,0,1,27.59-7.42,201.21,201.21,0,0,1,28.55-3.32,192.43,192.43,0,0,1,57.34,6.07,215.38,215.38,0,0,1,27.6,9.23,199.18,199.18,0,0,1,50.08,30.29,209.93,209.93,0,0,1,21.29,20.43,203.4,203.4,0,0,1,18.23,23.58A228.31,228.31,0,0,1,687.25,301Z",
    transform: "translate(-9.98 -137.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M962.67,461.32c-6.21-66.18-18-161.65-21.78-186.88l4.12-.25a35.32,35.32,0,0,1,37.46,33L990,424.69A35.32,35.32,0,0,1,962.67,461.32Z",
    transform: "translate(-9.98 -137.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.44,274.55c-3.77,25.39-15.6,121-21.77,187.07a35.32,35.32,0,0,1-28.62-36.93l7.48-117.47a35.33,35.33,0,0,1,37.5-33Z",
    transform: "translate(-9.98 -137.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(64.5 702.95)"
  }, "s", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 111.24,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 158.46,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 202.27,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 323.54,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 430.19,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 530.01,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 641.25,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 745.47,
    y: 0
  }, "y")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverLogoSvg);
export default __webpack_public_path__ + "static/media/SilverLogo_SVG.310bc4f42ac7613cffb0c4099886aa1e.svg";
export { ForwardRef as ReactComponent };